import {inject, Injectable} from '@angular/core';
import {UsernameData} from "../types/add-cooperation-offer.types";
import {defaultUsernameData} from "../configs/add-cooperation-offer-config";
import {RecordData, RecordsDataRequestQueryParams} from "../../../../types/records-table.types";
import {RepeatsModalService} from "../../repeats-modal/services/repeats-modal.service";

@Injectable({
  providedIn: 'root'
})
export class AddCooperationOfferService {
  private repeatsModalService: RepeatsModalService = inject(RepeatsModalService);

  public extractUsername(url: string): UsernameData {
    const segments = url.split('/').filter(Boolean);
    const lastSegment = segments[segments.length - 1] || null;

    if (!lastSegment) { return defaultUsernameData; }

    const rawUsername = lastSegment.split('?')[0];
    const username = rawUsername.startsWith('@') ? rawUsername.slice(1) : rawUsername;

    return { username, rawUsername };
  }

  public extractUrl(url: string, rawUsername: string | null): string | null {
    if (!rawUsername) { return null; }

    const index = url.lastIndexOf(rawUsername);
    return index !== -1 ? url.substring(0, index) : null;
  }

  public getSearchRepeatsForRecordsList(queryParams: RecordsDataRequestQueryParams):Promise<Array<RecordData>> {
    return new Promise((resolve, reject) => {
      this.repeatsModalService.getSearchRepeatsForRecordsList(queryParams).subscribe({
        next: (recordTableData: Array<RecordData>) => resolve(recordTableData),
        error: (error) => reject(error)
      });
    });
  }
}
